import { createAsyncReducer } from 'utils/Redux';

import { GenericResponse } from './../../types/GenericResponse';
import { creativeStudioAction } from '../actions';

export default createAsyncReducer<null, GenericResponse>(
  creativeStudioAction.getBrandKitAction,
);
